const TimeTracker = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='81' height='74' viewBox='0 0 81 74' fill='none'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M18.668 11.2874C32.8689 -2.91349 55.8932 -2.9135 70.094 11.2874C84.2947 25.4882 84.2947 48.5124 70.094 62.7132C55.8932 76.914 32.8689 76.914 18.6681 62.7132C17.248 61.2931 17.248 58.9907 18.668 57.5706C20.0881 56.1505 22.3905 56.1505 23.8106 57.5706C35.1713 68.9312 53.5908 68.9312 64.9514 57.5706C76.312 46.21 76.312 27.7906 64.9514 16.4299C53.5907 5.06926 35.1713 5.06926 23.8106 16.4299C18.1259 22.1146 15.2865 29.5592 15.2901 37.0147L15.29 44.2729C15.29 46.2812 13.662 47.9092 11.6537 47.9092C9.64535 47.9092 8.01731 46.2811 8.01733 44.2728L8.01741 37.0173C8.01741 37.0171 8.01741 37.0177 8.01741 37.0173C8.01331 27.7113 11.5642 18.3912 18.668 11.2874Z'
        fill='#C84B31'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1.80969 34.4291C3.22978 33.009 5.53219 33.009 6.95228 34.4291L11.6537 39.1305L16.3551 34.4291C17.7752 33.009 20.0776 33.009 21.4977 34.4291C22.9178 35.8492 22.9178 38.1516 21.4977 39.5717L14.225 46.8444C12.8049 48.2645 10.5025 48.2645 9.0824 46.8444L1.80969 39.5717C0.389608 38.1516 0.389608 35.8492 1.80969 34.4291Z'
        fill='#C84B31'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M40.7445 18.8186C42.7528 18.8186 44.3809 20.4467 44.3809 22.455V37.0002H58.9263C60.9346 37.0002 62.5626 38.6283 62.5626 40.6366C62.5626 42.6449 60.9346 44.2729 58.9263 44.2729H40.7445C38.7362 44.2729 37.1082 42.6449 37.1082 40.6366V22.455C37.1082 20.4467 38.7362 18.8186 40.7445 18.8186Z'
        fill='#C84B31'
      />
    </svg>
  );
};

export default TimeTracker;
